import React from 'react';
import Meta from '../components/Meta';
import HeaderSection from "../components/header/HeaderSection";

const CodeOfConduct = () => {
  return (
    <>
      <Meta title="Code Of Conduct - The Engineering Book Club"/>

      <HeaderSection title="Code Of Conduct" subtitle="Last updated April, 2023"/>

      <section className="relative py-1 md:py-24">
        <div className="container">
          <div className="mx-auto max-w-[48.125rem]">

            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              The Engineering Book Club (EBC) is a space where professionals at all stages of their engineering journey can gather, connect, and learn without fear of harassment, prejudice, or
              discrimination. To that end, we enforce the following rules, and by joining this community, you agree to adhere to these rules or face removal from this community.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Our Pledge
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              We as members, contributors, and leaders pledge to make participation in our community a harassment-free experience for everyone, regardless of age, body size, visible or invisible
              disability, ethnicity, sex characteristics, gender identity and expression, level of experience, education, socio-economic status, nationality, personal appearance, race, caste,
              color,
              religion, or sexual identity and orientation.
            </p>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              We pledge to act and interact in ways that contribute to an open, welcoming, diverse, inclusive, and healthy community.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Our Standards
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              <b>Examples of behaviour that contributes to a positive environment for our community include:
              </b>
            </p>
            <ul>
              <li>- Demonstrating empathy and kindness toward other people.</li>
              <li>- Being respectful of differing opinions, viewpoints, and experiences.</li>
              <li>- Giving and gracefully accepting constructive feedback.</li>
              <li>- Accepting responsibility, apologizing to those affected by our mistakes, and learning from the experience.</li>
              <li>- Focusing on what is best not just for us as individuals but for the overall community.‍</li>
            </ul>
            <br/>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              <b>Examples of unacceptable behavior include:</b>
            </p>
            <ul>
              <li>- The use of sexualized language or imagery and sexual attention or advances of any kind.</li>
              <li>- Trolling, insulting or derogatory comments, and personal or political attacks.</li>
              <li>- Public or private harassment. This includes discriminatory or prejudicial comments.</li>
              <li>- Publishing others' private information, such as a physical or email address, without explicit permission.</li>
              <li>- Other conduct that could reasonably be inappropriate in a professional setting.</li>
            </ul>
            <br/>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              We also enforce the following rules to ensure members feel comfortable being open and vulnerable in the questions they ask and the relationships they build in the community:
              No spammy behaviour
            </p>
            <br/>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Light self-promotion is fine, but you can't constantly promote your business/podcast/etc. Participate organically!
              No straight-up marketing, please. Again, participate organically!
              No random links to non-community stuff.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Keep it on-topic
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              This is primarily a place for folks in the community world to talk all things community, with general chat okay in appropriate channels.
              Top-level comments should be made in the appropriate channel; if an off-topic comment is posted, it will be removed.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Use real names and photos
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Pseudonymous communities are great and have their place. This space is for meeting others and building professional relationships, so real names and photos should be used.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Introduce yourself
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              One of the requisites for full access to the community is introducing yourself in the Say Hello section. Share where you are based, what your interests are, and what your
              professional experience is.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Keep it above board
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Don't post, share, or solicit illegal content.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Don't be a jerk
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              If you're found to be harassing or being a jerk to anyone else in our community, you're out of here.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              No politics
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              We know that political discourse, especially now, is critical. This rule isn't meant to stifle beliefs or ideals, it's simply meant to avoid intense, heated political discussions in
              our community.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              This is not a marketplace
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              We're not here for you to sell things through our community.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Enforcement Policy
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              If you are found in violation of the above Code of Conduct or any of the additional community rules, you will receive a warning about your behavior. Additional instances of
              rule-breaking will be met with your removal from the community. If your behavior is unacceptable or you use our community for illegal activities, you will be immediately removed from
              the community.
            </p>
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">
              Reporting Guidelines
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              If you find someone in violation of our community Code of Conduct or rules, please either DM one of our Community Managers (Miguel Martin, Jose A Lobato). Where possible, please
              include a direct link to the violation and/or a screenshot.
            </p>

          </div>
        </div>
      </section>
    </>
  );
};

export default CodeOfConduct;
